<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 0.5V8C1 9.65685 2.34315 11 4 11H11.5" stroke="#A1A1AA" />
  </svg>
</template>
